import { Resource } from 'src/app/global/domain/resource.model';
import { ConciliacaoDTO } from './dto/conciliacao.dto';
import { TipoConciliacaoBancaria } from './enum/tipo-conciliacao-bancaria.enum';

export class ConciliacaoBancariaDoc extends Resource {
  data: Date;

  name: string;

  identificador: string;

  tipoConciliacaoBancaria: TipoConciliacaoBancaria;

  banco: number;

  valor: number;

  processado: boolean;

  valorPago: number;

  conta: string;

  agencia: string;

  public static toConciliacaoDTO(conciliacao: ConciliacaoBancariaDoc): ConciliacaoDTO {
    let dto: ConciliacaoDTO = {
      id: conciliacao.id,
      version: conciliacao.version,
      ativo: conciliacao.ativo,
      selecionado: conciliacao.selecionado,
      acoes: conciliacao.acoes,
      data: conciliacao.data,
      name: conciliacao.name,
      identificador: conciliacao.identificador,
      tipoConciliacaoBancaria: conciliacao.tipoConciliacaoBancaria,
      banco: conciliacao.banco,
      valor: conciliacao.valor,
      conta: null,
      agencia: conciliacao.agencia,
      responsavel: null,
      processado: conciliacao.processado,
      valorPago: conciliacao.valorPago,
      contaDestino: null,
      contaOrigem: null,
    };
    return dto;
  }
}
